(function () {
  var ROOT_SELECTOR = '[data-collection-side-nav]';
  var ICON_CARET = '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M9.354 0.646a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708 0l-4-4A.5.5 0 1 1 1.354.646L5 4.293 8.646.646a.5.5 0 0 1 .708 0z"></path></svg>';
  var menuCache = Object.create(null);

  function normalizePath(url) {
    if (!url) return null;
    try {
      var parsed = new URL(url, window.location.origin);
      var pathname = parsed.pathname || '/';
      return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    } catch (e) {
      return null;
    }
  }

  function imageSizeUrl(url, width, height) {
    if (!url) return '';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + width + '&height=' + height + '&crop=center';
  }

  function fetchMenu(src) {
    if (menuCache[src]) return menuCache[src];
    menuCache[src] = fetch(src, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('Menu fetch failed: ' + res.status);
      return res.json();
    });
    return menuCache[src];
  }

  function walk(items, parentId, depth, out) {
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      var children = Array.isArray(item.children) ? item.children : [];
      out.push({
        id: item.id,
        parentId: parentId,
        depth: depth,
        urlPath: normalizePath(item.url),
        hasChildren: children.length > 0
      });
      if (children.length) walk(children, item.id, depth + 1, out);
    }
  }

  function buildState(items, currentPath) {
    var flat = [];
    walk(items, null, 0, flat);

    var parentById = Object.create(null);
    var canonicalOwnerByPath = Object.create(null);
    var activeId = null;

    for (var i = 0; i < flat.length; i += 1) {
      var node = flat[i];
      parentById[node.id] = node.parentId;
      if (!node.urlPath) continue;
      if (!canonicalOwnerByPath[node.urlPath]) {
        canonicalOwnerByPath[node.urlPath] = node.id;
      }
    }

    if (canonicalOwnerByPath[currentPath]) {
      activeId = canonicalOwnerByPath[currentPath];
    }

    var openIds = Object.create(null);
    if (activeId) {
      var cursor = activeId;
      while (cursor) {
        openIds[cursor] = true;
        cursor = parentById[cursor];
      }
    }

    return {
      activeId: activeId,
      openIds: openIds
    };
  }

  function createTextNode(title) {
    var textWrap = document.createElement('span');
    textWrap.className = 'collection-side-nav__text';
    textWrap.textContent = title;
    return textWrap;
  }

  function createThumb(item) {
    if (!item.image) return null;
    var img = document.createElement('img');
    img.className = 'collection-side-nav__thumb';
    img.src = imageSizeUrl(item.image, 56, 56);
    img.srcset = imageSizeUrl(item.image, 56, 56) + ' 56w, ' + imageSizeUrl(item.image, 80, 80) + ' 80w';
    img.sizes = '56px';
    img.alt = item.title || '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = 56;
    img.height = 56;
    return img;
  }

  function renderLeaf(item, state) {
    var link = item.url ? document.createElement('a') : document.createElement('span');
    link.className = 'collection-side-nav__link';

    if (item.url) {
      link.href = item.url;
      if (state.activeId === item.id) {
        link.className += ' is-active';
        link.setAttribute('aria-current', 'page');
      }
    }

    var thumb = createThumb(item);
    if (thumb) link.appendChild(thumb);
    link.appendChild(createTextNode(item.title));
    return link;
  }

  function closeSiblingBranches(detailsEl) {
    var parentList = detailsEl.closest('ul');
    if (!parentList) return;
    var siblings = parentList.children;
    for (var i = 0; i < siblings.length; i += 1) {
      var siblingDetails = siblings[i].firstElementChild;
      if (
        siblingDetails &&
        siblingDetails.tagName === 'DETAILS' &&
        siblingDetails.classList.contains('collection-side-nav__branch')
      ) {
        if (siblingDetails !== detailsEl) {
          siblingDetails.open = false;
        }
      }
    }
  }

  function renderNode(item, state) {
    var li = document.createElement('li');
    li.className = 'collection-side-nav__item';

    var children = Array.isArray(item.children) ? item.children : [];
    if (!children.length) {
      li.appendChild(renderLeaf(item, state));
      return li;
    }

    var details = document.createElement('details');
    details.className = 'collection-side-nav__branch';
    if (state.openIds[item.id]) details.open = true;

    var summary = document.createElement('summary');

    var summaryLink = document.createElement('span');
    summaryLink.className = 'collection-side-nav__link';
    summaryLink.appendChild(createTextNode(item.title));
    summary.appendChild(summaryLink);

    var chevron = document.createElement('span');
    chevron.className = 'collection-side-nav__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    chevron.innerHTML = ICON_CARET;
    summary.appendChild(chevron);

    var childList = document.createElement('ul');
    childList.className = 'collection-side-nav__list collection-side-nav__list--child';
    childList.setAttribute('role', 'list');

    for (var i = 0; i < children.length; i += 1) {
      childList.appendChild(renderNode(children[i], state));
    }

    details.addEventListener('toggle', function () {
      if (details.open) closeSiblingBranches(details);
    });

    details.appendChild(summary);
    details.appendChild(childList);
    li.appendChild(details);
    return li;
  }

  function renderMenu(container, menuData) {
    var items = Array.isArray(menuData.items) ? menuData.items : [];
    var currentPath = normalizePath(window.location.pathname || '/');
    var state = buildState(items, currentPath);

    var rootList = document.createElement('ul');
    rootList.className = 'collection-side-nav__list';
    rootList.setAttribute('role', 'list');

    for (var i = 0; i < items.length; i += 1) {
      rootList.appendChild(renderNode(items[i], state));
    }

    container.innerHTML = '';
    container.appendChild(rootList);
  }

  function initOne(container) {
    if (!container || container.dataset.collectionSideNavReady === '1') return;
    var src = container.getAttribute('data-menu-src');
    if (!src) return;

    fetchMenu(src)
      .then(function (menuData) {
        renderMenu(container, menuData);
        container.dataset.collectionSideNavReady = '1';
      })
      .catch(function () {
        container.dataset.collectionSideNavReady = 'error';
      });
  }

  function initAll() {
    var nodes = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < nodes.length; i += 1) {
      initOne(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
